function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoUserTemplate = require('./saito-user.template');
var SaitoUser = /*#__PURE__*/function () {
  function SaitoUser(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var publicKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var notice = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var fourthelem = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
    _classCallCheck(this, SaitoUser);
    this.app = app;
    this.mod = mod;
    this.publicKey = publicKey;
    this.notice = notice;
    this.fourthelem = fourthelem;
    this.container = container;
    this.extra_classes = '';
    this.data_disable = false; // prevent click to open user-menu
  }
  return _createClass(SaitoUser, [{
    key: "updateUserline",
    value: function updateUserline(userline) {
      var qs = this.container + "> .saito-user-".concat(this.publicKey, " .saito-userline");
      var elem = document.querySelector(qs);
      if (elem) {
        elem.innerHTML = userline;
        if (userline) {
          elem.classList.remove('hidden');
        } else {
          elem.classList.add('hidden');
        }
      }
    }
  }, {
    key: "updateAddress",
    value: function updateAddress(address) {
      var qs = this.container + "> .saito-user-".concat(this.publicKey, " .saito-address");
      if (document.querySelector(qs)) {
        document.querySelector(qs).innerHTML = address;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var qs = this.container + "> .saito-user-".concat(this.publicKey);
      if (document.querySelector(qs)) {
        this.app.browser.replaceElementBySelector(SaitoUserTemplate(this), qs);
      } else {
        this.app.browser.addElementToSelector(SaitoUserTemplate(this), this.container);
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = SaitoUser;